/* eslint-disable no-return-await */
import 'regenerator-runtime/runtime'
const isOnline = require('is-online')

export const getIsOnline = async () => {
  return await isOnline()
}
